import axios from 'axios'
import Vue from 'vue'

export async function fetchRoles(context, payload){
    try{
        context.commit('flushRol')
        let url = "api/getroles"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setRoles', response.data)

    }catch(error){
        context.commit('rolesError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }

}
/**
 * Metodo que crea el rol
 * @param {} context 
 * @param {*} payload 
 */
export async function crearRol(context, payload){
    try{
        let url = "api/crearrol"
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        values.append('description',payload.description)
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        context.dispatch('fetchRoles')

    }
    catch(error){
        context.commit('rolesError',error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }

}
/**
 * Metodo que actualiza el rol, por ahora solo el nombre
 * @param {} context 
 * @param {*} payload 
 */
export async function actualizarRol(context, payload){
    try{
        let url ="api/actualizarrol"
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        values.append('description',payload.description)
        values.append('id',payload.id)
        let response = await Vue.axios({
            method:'POST',
            url: url,
            data: values
        })
        context.dispatch('fetchRoles') //llamamos a los roles
    }
    catch{
        context.commit('rolesError',error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}